import { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds  } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import moment from 'moment-hijri';
const TITLE = "كم باقي على عيد الفطر 2026 العد التنازلي لعيد الفطر 2026";
const DESCRIPTION = "كم باقي على العيد، عيد الفطر 2026، متى العيد، كم باقي للعيد، متى العيد 2026، تاريخ عيد الأضحى 2026، موعد عيد الأضحى 2026، كم باقي على العيد 2026، عيد الفطر ٢٠٢٤، كم باقي على عيد الفطر، كم باقي يوم على العيد، العيد الفطر 2026، عيد اضحى 2026، كم باقي على العيد الفطر 2026، العيد الكبير 2026، موعد عيد الفطر ٢٠٢٤، تاريخ العيد، كم باقي على يوم عرفه, متى عيد الفطر, متى تكون وقفة يوم عرفة 2026, موعد عيد الفطر, كم يوم باقي لعيد الفطر, عيد الأضحى,تاريخ عيد الفطر, العيد الفطر,  عيد الاضحي, كم باقي على عيد الفطر, عيد الأضحى, عيد الفطر 2026, عيد الفطر 1444 هجري, كم باقي على عيد الفطر 2026, كم باقي لعيد الفطر, كم باقي لعيد الفطر 2026, موعد عيد الفطر 2026, عيد الفطر المبارك, عيد الفطر، تاريخ عيد الفطر 2026، كم باقي لعيد الفطر، كم باقي على العيد الفطر، كم باقي للعيد، العيد الفطر 2026";
const KEYWORDS = "كم باقي على العيد، عيد الفطر 2026، متى العيد، كم باقي للعيد، متى العيد 2026، تاريخ عيد الأضحى 2026، موعد عيد الأضحى 2026، كم باقي على العيد 2026، عيد الفطر ٢٠٢٤، كم باقي على عيد الفطر، كم باقي يوم على العيد، العيد الفطر 2026، عيد اضحى 2026، كم باقي على العيد الفطر 2026، العيد الكبير 2026، موعد عيد الفطر ٢٠٢٤، تاريخ العيد، كم باقي على يوم عرفه, متى عيد الفطر, متى تكون وقفة يوم عرفة 2026, موعد عيد الفطر, كم يوم باقي لعيد الفطر, عيد الأضحى,تاريخ عيد الفطر, العيد الفطر,  عيد الاضحي, كم باقي على عيد الفطر, عيد الأضحى, عيد الفطر 2026, عيد الفطر 1444 هجري, كم باقي على عيد الفطر 2026, كم باقي لعيد الفطر, كم باقي لعيد الفطر 2026, موعد عيد الفطر 2026, عيد الفطر المبارك, عيد الفطر، تاريخ عيد الفطر 2026، كم باقي لعيد الفطر، كم باقي على العيد الفطر، كم باقي للعيد، العيد الفطر 2026";
const OG_URL = "https://do-calculate.com/articles-ar/eid-fatr";
function Ramadan() {
    const [eidDates, setEidDates] = useState([
        { name: 'عيد الفطر 2026', date: new Date("2026-03-20T00:00:00") },
        { name: 'عيد الفطر 2027', date: new Date("2027-03-10T00:00:00") },
        { name: 'عيد الفطر 2028', date: new Date("2028-02-27T00:00:00") },
        { name: 'عيد الفطر 2029', date: new Date("2029-02-15T00:00:00") }
    ]);
    const nextEid = eidDates.find(d => d.name === 'عيد الفطر 2026')?.date || new Date("2026-03-20T00:00:00");
    const dayNameArabic = nextEid.toLocaleDateString('ar-EG', { weekday: 'long' });
    useEffect(() => {
        async function fetchEidDates() {
            try {
                const datesCol = collection(db, "dates");
                const querySnapshot = await getDocs(datesCol);
                let fetchedEid2026Date = null;
                const newEidDates = [];
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    if (data.eid_fitr) {
                        const date = data.eid_fitr.toDate ? data.eid_fitr.toDate() : new Date(data.eid_fitr);
                        if (date.getFullYear() === 2026) {
                            fetchedEid2026Date = date;
                            newEidDates.push({ name: 'عيد الفطر 2026', date: date });
                        }
                    }
                });
                if (fetchedEid2026Date) {
                    setEidDates(prevDates =>
                        prevDates.map(item =>
                            item.name === 'عيد الفطر 2026'
                                ? { ...item, date: fetchedEid2026Date }
                                : item
                        )
                    );
                } else {
                    console.warn("No Eid al-Fitr 2026 date found in DB. Using default.");
                }
            } catch (error) {
                console.error("Error fetching Eid dates:", error);
            }
        }
        fetchEidDates();
    }, []);
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(nextEid));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(nextEid));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft, nextEid]);
    return (
        <div className="rtl">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                كم باقي على عيد الفطر 2026
            </h1>
            <div>
                <BlinkingText
                    text={`كم باقي على عيد الفطر: من المتوقع أن يبدأ عيد الفطر 2026 يوم ${dayNameArabic} بتاريخ ${nextEid?.toLocaleDateString('en-GB')} ميلادي و ${moment(nextEid).format('iDD/iMM/iYYYY')} هجري.`}
                />            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header"  >يوم</th>
                                <th className="bmi-header" >ساعة</th>
                                <th >دقيقة</th>
                                <th >ثوانٍ</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days" >{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes" >{timeLeft.minutes}</td>
                                <td id="seconds" >{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>مواعيد عيد الفطر القادمة</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>موعد عيد الفطر</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>التاريخ</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>باقي</th>
                                </tr>
                            </thead>
                            <tbody>
                                {eidDates.map((eid, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{eid.name}</td>
                                        <td style={{ padding: '12px' }}>{eid.date.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(eid.date).days} يوم</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>كم باقي على عيد الفطر 2026</h3>
                    <p>
                        في هذا المقال، نقدم لكم العد التنازلي المفصل ل عيد الفطر المبارك، لتكونوا على اطلاع دائم بكم يوم باقٍ على وصول هذا ال الفضيل.الكثير منا يتسائلون كم باقي على  عيد الفطر المبارك، لهذا نقدم لكم في هذا المقال العد التنازلي ل عيد الفطر المبارك لتتكمنوا من معرفة كم باقي على عيد الفطر، كم باقي ع عيد الفطر، كم يوم باقي على عيد الفطر شاهدوا العد التنازلي عيد الفطر المبارك في الأعلى.
                    </p>
                    <p>
                        وفقا لموقع <a href='/calculator/ar/gregorian_to_hijri/'>تحويل التاريخ</a> يصادف عيد الفطر 2026 يوم السبت {nextEid?.toLocaleDateString('en-GB')} ميلادي و{moment(nextEid).format('iDD/iMM/iYYYY')} هجري، يمكنكم مشاهدة العد التنازلي لعيد الفطر 2026 في هذا المقال.
                    </p>
                    <p>تجدون هنا العد التنازلي لعيد الفطر، حيث يمكنكم معرفة كم باقي يوم على عيد الفطر الكريم.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        احسب كم باقي لعيد الفطر الكريم
                    </h3 >
                    <p>
                        من خلال برنامج حساب العد التنازلي لعيد الفطر يمكنكم معرفة كم باقي لعيد الفطر بالتقويم الميلادي والهجري، كما يمكنكم معرفة باقي على عيد الفطر كم يوم، وكم تبقى لعيد الفطر، كم تبقي لعيد الفطر بالأيام, ومتى عيد الفطر العد التنازلي، باقي على عيد الفطر، كم تبقى على عيد الفطر، كم باقي ع عيد الفطر، باقي كم يوم على عيد الفطر، كم باقي عن عيد الفطر، كم تبقى لعيد الفطر، كم متبقي على عيد الفطر، كم يوم باقي لعيد الفطر، كم يوم على عيد الفطر، كم بقي على عيد الفطر، كم باقي على  عيد الفطر، باقى كام يوم على عيد الفطر،  وموعد عيد الفطر المبارك لهذه السنة، كل عام وانتم بخير وأعاده ال له علينا وعليكم باليمن والبركات.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        عيد الفطر
                    </h3>
                    <p>
                        العيد مظهرٌ من مظاهر الدين، وشعيرة من شعائره المعظمة، والنفوس مجبولة على حب الأعياد والسرور بها، وقد جاءت سنة النبي ـ صلى الله عليه وسلم ـ بمشروعية عيدي الفطر والأضحى، فعن أنس - رضي الله عنه - قال: ( قَدِم النبيّ ـ صلى الله عليه وسلم ـ المدينة ولهم يومان يلعبون فيهما، فقال: قد أبدلكم الله تعالى بهما خيراً منهما: يومَ الفطر والأضحى ) رواه أبو داود .
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="كم باقي على  عيد الفطر"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        من آداب العيد :
                    </h3>
                    <p>
                        ـ الاغتسال والتجمل للعيد، وقد نقل ذلك عن عدد من السلف من الصحابة ومن بعدهم، اقتداء بالنبي ـ صلى الله عليه وسلم ـ، قال ابن القيم: " وكان ـ صلى الله عليه وسلم ـ يلبس لهما ( أي للعيدين ) أجمل ثيابه، وكان له حُلة يلبسها للعيدين والجمعة " .
                        والرجل يخرج على هذه الصفة من التجمل، وأما النساء فإنهن إذا خرجن لصلاة العيد وغيرها يخرجن على الصفة التي أذن بها لهن النبي ـ صلى الله عليه وسلم ـ إذا شهدن الصلاة حيث قال: ( لا تمنعوا إماء الله مساجد الله ولكن ليخرجن وهن تَفِلات (غير متطيبات) ) رواه أبو داود . <br />
                        قال ابن حجر: " ويلحق بالطيب ما في معناه، لأن سبب المنع منه ما فيه من تحريك داعية الشهوة، كحسن الملبس والحلي الذي يظهر، والزينة الفاخرة، وكذا الاختلاط بالرجال " .<br />
                        وفي عيد الفطر يُشرع التكبير من ليلة العيد حتى حضور الصلاة، حيث ثبت عنه ـ صلى الله عليه وسلم ـ أنه كان يخرج يوم الفطر فيكبِّر حتى يأتي المُصلَّى، وحتى يقضيَ الصلاة، فإذا قضى الصلاة قطع التكبير .
                    </p>
                    المصدر : <a href='https://www.islamweb.net/ar/article/189088/'>إسلام ويب</a>
                    <ul>
                    </ul>
                </div>
                <br />
            </div>
        </div>
    );
}
export default Ramadan;